import { useEffect } from "react";
import {
  ACTIVATION_MODAL_KEY,
  useSessionStorage,
} from "react/components/NewVersionOptIn/OptInLandingPage/hooks/useSessionStorage";
import { useCircleV4 } from "react/hooks/useCircleV4";

import { useVersionActivationModal } from "..";

export const useRenderVersionActivationModal = () => {
  const { isCircleV4Enabled } = useCircleV4();

  const modal = useVersionActivationModal();
  const {
    get: shouldShowActivationModal,
    remove: disableShowingActivationModalOnNextRender,
  } = useSessionStorage<boolean>(ACTIVATION_MODAL_KEY);

  useEffect(() => {
    if (!isCircleV4Enabled) return;

    if (shouldShowActivationModal({ onErrorValue: true })) {
      disableShowingActivationModalOnNextRender();
      void modal.show();
    }
  }, [
    modal,
    shouldShowActivationModal,
    disableShowingActivationModalOnNextRender,
    isCircleV4Enabled,
  ]);
};
